import {forwardRef} from "react";
import {IProtocolStep} from "../../types/protocol";
import {Box, BoxProps} from "@mantine/core";
import {Dayjs} from "dayjs";
import {ZoneAwareDateTimePicker} from "@/common/components/ZoneAwareDateTimePicker";
import {DeepPartial} from "@/utils/types/DeepPartial";
import {DateTimePickerProps} from "@mantine/dates";

interface StepZoneAwareDateTimePickerProps extends BoxProps {
    timezone?: string
    step: IProtocolStep
    onChange: (updates: DeepPartial<IProtocolStep>) => void
    label?: string
    propertyName: "startTime" | "endTime"
    dateTimeProps?: Exclude<DateTimePickerProps, 'value' | 'onChange'> & {"data-testid"?: string}
    readonly?: boolean
}

export const StepZoneAwareDateTimePicker = forwardRef<HTMLDivElement, StepZoneAwareDateTimePickerProps>(
    ({step, onChange, propertyName, label, timezone, dateTimeProps, readonly = false, ...others}, ref) => {

        const getValue = (): Dayjs | undefined => {
            if (propertyName === "startTime") {
                return step[propertyName]
            }
            if (propertyName === "endTime" && "endTime" in step) {
                return step[propertyName]
            }
            return undefined
        }

        const onValueChange = (value: Dayjs) => {
            onChange({
                [propertyName]: value
            })
        }

        return (
            <Box ref={ref} {...others}>
                <ZoneAwareDateTimePicker
                    timezone={timezone}
                    value={getValue()}
                    onChange={onValueChange}
                    readonly={readonly}
                    label={label}
                    dateTimeProps={{...dateTimeProps, "data-testid": `time-input-${propertyName}`}}
                />
            </Box>
        )
    }
)
